(function(){
    'use strict'

    angular
    .module('app.procesosMasivos')
    .controller('ProcesosMasivos', ProcesosMasivos);

    ProcesosMasivos.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'ProcesosMasivosService', 'DepartamentosService', 'TiposPlanillaService', 'PuestosService', 'EmpleadosService', 'logger', '$location', 'UserInfoService', 'moment'];

    function ProcesosMasivos($q, $scope, $animationsSrv, $routeParams, ProcesosMasivosService, DepartamentosService, TiposPlanillaService, PuestosService, EmpleadosService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var searchKey = "Procesos_Masivos_Search_Criteria";

        vm.departamentos = [];
        vm.puestos = [];
        vm.tiposPlanilla = [];
        vm.tiposProceso = [];

        vm.procesosMasivos = [];

        vm.procesoMasivo = {
            tipoPlanillaId: -1,
            empleadoDepartamento: -1,
            empleadoPuesto: -1,
            tipoProceso: -1,
            empleadoNombre: '',
            empleadoIdentificacion: '',
            companiaId: UserInfoService.getCompaniaId()
        };

        vm.title = 'Procesos Masivos';

        vm.search = function(){

            var promise = ProcesosMasivosService.search(vm.procesoMasivo)
            .then(function(procesos){
                UserInfoService.saveDataOnSessionStorage(searchKey, vm.procesoMasivo);
                vm.procesosMasivos = procesos.data;
            })
            .catch(function(error){
                logger.error('Error al obtener los datos de los procesos ejecutados.');
            }); 
        
        };

        var promiseDepartamento = getDepartamentos();
        var promisePuesto = getPuestos();
        var promiseTipoPlanilla = getTiposPlanilla();
        var promiseTipoProceso = getTiposProceso();

        CargarPreviousSearch();

        function CargarPreviousSearch(){
            var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
            if(previousSearch){
                vm.procesoMasivo = previousSearch;
                $q.all([promiseDepartamento, promisePuesto, 
                        promiseTipoPlanilla, promiseTipoProceso]).then(function(){

                    vm.search();
                });               
            }
            else{
                vm.search();
            }

        }

        vm.goToDetalle = function(proceso){
            
            var path = '/proceso-masivo-detalle/';

            if(proceso){
                $location.path(path + proceso.companiaId + '/' + proceso.id);
            }
            else{
                logger.error('No fue posible cargar los datos del detalle del proceso');
            }
            
        };


        vm.clearCriteria = function(){
            vm.procesoMasivo = {
                tipoPlanillaId: -1,
                empleadoDepartamento: -1,
                empleadoPuesto: -1,
                tipoProceso: -1,
                empleadoNombre: '',
                empleadoIdentificacion: '',
                companiaId: UserInfoService.getCompaniaId()
            };
        };

        function getDepartamentos(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        function getTiposProceso(){
            var promise = ProcesosMasivosService.getTipos()
            .then(function(tiposProceso){
                vm.tiposProceso = tiposProceso;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de procesos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getPuestos(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        vm.reversar = function(proceso){

            var promise = ProcesosMasivosService.reversar(proceso)
            .then(function(result){
                if(result.data)
                {
                    proceso.revertido = true;
                    logger.success('Proceso revertido con éxito.');
                }
            })
            .catch(function(error){
                logger.error(`Error al revertir el proceso. ${error.data.Message}`);
            }); 
        
        };

    }
})();